import { useResponsive } from './useResponsive';

/**
 * The width below which the app renders its MOBILE SHELL: the mobile
 * navigation (drawer closed by default, bottom bar instead of a mini-bar), the
 * player's full-width bottom actions and portrait layout, the PWA install
 * prompt, the "view all" affordances that collapse on small screens.
 *
 * This is a DECISION, not a derivation. It equals Tailwind's `md` stop (and,
 * since the two scales were aligned, MUI's) because the app's layout structure
 * is authored against that scale — but the shell must never follow a scale
 * change silently. The last time the scale moved (MUI `md` 900 → 768) every
 * `useResponsive('down', 'md')` that really meant "mobile shell" moved with
 * it, and an iPad in portrait switched shells without a single diff line
 * saying so. Change the number HERE, consciously; a guard spec in
 * `@mfw/frontend` (`theme/__tests__/mobileShellBreakpoint.spec.ts`) fails the
 * moment either side drifts, naming the side that moved.
 *
 * Pure spacing and density (padding, gaps, toolbar widths) stay on the
 * breakpoint tokens — those SHOULD follow the scale.
 */
export const MOBILE_SHELL_MAX_WIDTH = 768;

/** `true` while the viewport is narrower than {@link MOBILE_SHELL_MAX_WIDTH}. */
export function useIsMobileShell() {
  // A number, not a token: `breakpoints.down(768)` is `max-width: 767.95px`
  // whatever `theme.breakpoints.values.md` happens to be.
  return useResponsive('down', MOBILE_SHELL_MAX_WIDTH);
}
